import React, { useCallback, useMemo, useState, useEffect } from "react";
import { DataGrid, List, ScrollArea } from "../../../../components";
import ReactPaginate from "react-paginate";
import { TriangleLeftIcon, TriangleRightIcon } from "@radix-ui/react-icons";
import { useNavigate } from "react-router-dom";
import { GlobalFilters, GlobalSearch } from "../../../../components/filters";
import { useQuery } from "react-query";
import { getRequest, queries } from "../../../../react-query";


export const ActivityList = () => {
  let size = 10;
  const navigate = useNavigate();
  const [page, setPage] = useState<number>(1);

  const [input, setInput] = useState({
    filter: "ACTIVE",
    search: ""
  });

  const {
    data: activitiesData = [],
    isLoading,
    error,
  }: any = useQuery(
    [queries.activities, input.filter, page, size],
    () =>
      getRequest(
        `/activity?status=${input.filter}&page=${page}&pageSize=${size}`
      ),
    {
      enabled: !!page || !!input.filter,
    }
  );

  // Destructuring Data
  const { data: activities = [], pagination } = activitiesData;
  

  const totalPages = useMemo(
    () => Math.ceil(pagination?.totalCount / pagination?.pageSize),
    [pagination]
  );
  

  const onPageChangeHandler = useCallback((page: number) => {
    setPage(page + 1);
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "Activity Name",
        accessor: "name",
        disableFilters: true,
      },
      {
        Header: "Status",
        accessor: "status",
        disableFilters: true,
      },
      {
        Header: "Actions",
        accessor: "actions",
        disableFilters: true,
        Cell: ({ row }: any) => (
          <div className="flex space-x-2">
            <button
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/settings/activity/update/${row.original.id}`, {
                  state: { data: row.original },
                });
              }}
              className="bg-green text-white px-4 py-1 rounded-full text-sm hover:bg-[#228B22]"
            >
              Edit
            </button>
          </div>
        ),
      },
    ],
    [navigate]
  );

  const onValueChangeHandler = (value: string, name: string) => {
    if (value) {
      setInput({
        ...input,
        [name]: value,
      });
    }
  };


  
  const onRowHandler = (data: any) => {
    navigate(`/settings/activity/update/${data.id}`, {
      state: {
        data: data,
      },
    });
  };
  

  const goToCreatePage = () => {
    navigate("/settings/activity/create");
  };

  return (
    <div className="text-black space-y-4 py-4">
      <div className="flex justify-between items-center">
        <GlobalFilters
          filter={input["filter"]}
          setFilter={(value: string) => onValueChangeHandler(value, "filter")}
        />
        <div className="flex items-center space-x-4">
          <GlobalSearch
            value={input["search"]}
            setValue={(e: any) =>
              onValueChangeHandler(e.target.value, "search")
            }
          />
          <button
            onClick={goToCreatePage}
            className="bg-green text-white px-4 py-1 rounded-full text-sm hover:bg-[#228B22]"
          >
            Create
          </button>
        </div>
      </div>
      <ScrollArea className="w-full h-[calc(100vh-260px)]">
        <DataGrid
          data={activities}
          columns={columns}
           onRowHandler={onRowHandler}
        />
      </ScrollArea>

      <ReactPaginate
        containerClassName={"paginationContainer"}
        pageClassName={"paginationItem"}
        activeClassName={"paginationActive"}
        onPageChange={(event) => onPageChangeHandler(event.selected)}
        pageCount={totalPages}
        breakLabel="..."
        previousLabel={
          <TriangleLeftIcon className={`w-10 h-10 cursor-pointer`} />
        }
        nextLabel={<TriangleRightIcon className={`w-10 h-10 cursor-pointer`} />}
      />
    </div>
  );
};
